import React, { use, useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    className: '',
    level: '',
    loading: false,
}

const EditClassRoom = ({classInfo}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getClassLevels, classLevels, getClasses} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getClassLevels();
    }, [])

    useEffect(() => {
        if(classInfo){
            dispatch({type: 'className', value: classInfo.class_name});
            dispatch({type: 'level', value: {label: classInfo.level.level, value: classInfo.level.level_id}});
        }
    }, [classInfo]);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.className.length === 0 || !state.level.value){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.updateClass(classInfo.class_id, state.level.value, state.className);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getClasses(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


      const RenderClassLevel = () => {
        const options = [];
        if (Array.isArray(classLevels) && classLevels.length > 0) {
            classLevels.map((item, key) =>
                options.push({ label: item.level, value: item.level_id })
            );
        }

        return (
            <TextInput
                label="Class Level"
                type="select"
                leftIcon={true}
                placeholder={state.level.label || 'Select class level....'}
                options={options}
                onChange={(item) => dispatch({ type: 'level', value: item })}
                leftComponent={<i className="fa fa-bookmark link" onClick={getClassLevels}></i>}
                loading={!classLevels}
                wrap
            />
        );
    };


  

    return (
        <div className="card-body">

            <CallOut 
                title="Edit Class Room"
                description="E.g. S.1, S.2, S.3, etc."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Class Name"
                            placeholder="Class Name"
                            leftIcon="fa fa-school"
                            value={state.className}
                            onChange={e => dispatch({type: 'className', value: e.target.value})}
                            required
                            wrap
                            />

                        {RenderClassLevel()}
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Changes</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default EditClassRoom;